import { Box } from '@mui/material';
import { PropsWithChildren, ReactElement } from 'react';

type Props = PropsWithChildren<{
  show?: boolean;
}>;

export function Animate(p: Props): ReactElement {
  return (
    <Box
      sx={{
        opacity: p.show ? 1 : 0,
        transition: 'opacity 0.25s',
        display: 'inline',
      }}
    >
      {p.children}
    </Box>
  );
}
